import React, {useEffect, useState} from 'react'
import {Box} from '@mui/material'
import AppDialog from 'src/components-new/feedback/AppDialog'
import DataTable, {ColumnDef, PaginationState} from 'src/components-new/data/DataTable'
import TextFieldNew from 'src/components-new/inputs/TextFieldNew'
import Button from 'src/components-new/primitives/Button'
import apiClient from 'src/services/apiClient'

type CaregiversDialogProps = {
  elementToFilter?: Record<string, any>;
  onSave: (caregiver: Record<string, any>) => void;
  onClose: () => void;
};

const columns: ColumnDef<Record<string, any>>[] = [
  {key: 'title', header: 'Titolo', render: (row) => row.title ?? '—', hideInMobileCard: true},
  {key: 'lastName', header: 'Cognome', render: (row) => row.lastName ?? '—', hideInMobileCard: true},
  {key: 'firstName', header: 'Nome', render: (row) => row.firstName ?? '—', hideInMobileCard: true},
  {key: 'phoneNumber', header: 'Telefono', render: (row) => row.phoneNumber ?? '—'},
  {key: 'cellPhoneNumber', header: 'Cellulare', render: (row) => row.cellPhoneNumber ?? '—'},
]

function mobileCardTitle(row: Record<string, any>): string {
  return [`${row.title || ''}`, row.firstName, row.lastName].filter(Boolean).join(' ').trim() || '—'
}

const CaregiversDialogNew: React.FC<CaregiversDialogProps> = ({elementToFilter, onSave, onClose}) => {
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [filters, setFilters] = useState<any[]>([])
  const [fetchedData, setFetchedData] = useState<{data: Record<string, any>[], count: number}>({data: [], count: 0})
  const [pagination, setPagination] = useState<PaginationState>({page: 0, rowsPerPage: 10, order: ''})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      Promise.all([
        apiClient.getCaregivers(filters, () => undefined, pagination),
        apiClient.getCaregiversCount(filters, () => undefined),
      ]).then(([caregivers, count]) => {
        setFetchedData({
          data: caregivers.filter((el: any) => el._id !== elementToFilter?._id),
          count,
        })
        setLoading(false)
      })
    }
    fetchData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, pagination])

  const handleSearch = () => {
    const newFilters: any[] = []
    if (firstName) newFilters.push({property: 'firstName', type: 'text', value: firstName})
    if (lastName) newFilters.push({property: 'lastName', type: 'text', value: lastName})
    setFilters(newFilters)
    setPagination(prev => ({...prev, page: 0}))
  }

  const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === 'Enter') handleSearch()
  }

  return (
    <AppDialog open onClose={onClose} title="Lista caregivers/tutori" maxWidth="lg">
      <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
        <Box sx={{display: 'flex', flexDirection: {xs: 'column', sm: 'row'}, alignItems: {xs: 'stretch', sm: 'flex-end'}, gap: 1}}>
          <TextFieldNew
            label="Nome"
            value={firstName}
            onChange={setFirstName}
            onKeyDown={handleKeyDown}
            fullWidth
          />
          <TextFieldNew
            label="Cognome"
            value={lastName}
            onChange={setLastName}
            onKeyDown={handleKeyDown}
            fullWidth
          />
          <Button variant="primary" onClick={handleSearch} sx={{flexShrink: 0, height: 40, width: {xs: '100%', sm: 'auto'}}}>
            {'Cerca'}
          </Button>
        </Box>

        <DataTable
          columns={columns}
          rows={fetchedData.data}
          keyField="_id"
          loading={loading}
          onRowClick={onSave}
          pagination={pagination}
          totalElements={fetchedData.count}
          onPaginationChange={setPagination}
          mobileCardTitle={mobileCardTitle}
        />
      </Box>
    </AppDialog>
  )
}

export default CaregiversDialogNew
